module.exports = require("/home/amirmohammad/release/frontend/projects/landing-page/src/components/root-wrapper/styles-provider-props")